import "@sweetalert2/theme-material-ui/material-ui.css";
import BaseWal from "sweetalert2/src/sweetalert2.js";
import withReactContent from "sweetalert2-react-content";

export const Swal = withReactContent(BaseWal);
